<script>
	import { Route, Router } from "svelte-routing";
	import Group from "./Group/Group.svelte";
	import GroupDetails from "./Group/GroupDetails.svelte";
	import PresetTask from "./PresetTask/PresetTask.svelte";
	import VehicleData from "./VehicleData/VehicleData.svelte";
	import VehicleMake from "./VehicleData/VehicleMake/VehicleMake.svelte";
	import VehicleModel from "./VehicleData/VehicleModel/VehicleModel.svelte";
	import VehicleType from "./VehicleData/VehicleType/VehicleType.svelte";
	import VehicleColor from "./VehicleData/VehicleColor/VehicleColor.svelte";
	import VehicleFuel from "./VehicleData/VehicleFuel/VehicleFuel.svelte";
	import VehicleAssetOwner from "./VehicleData/CarAssetOwner/VehicleAssetOwner.svelte";
	import CarParkOwner from "./VehicleData/CarParkOwner/CarParkOwner.svelte";
	import FuelCompany from "./VehicleData/FuelCompany/FuelCompany.svelte";
	import VehiclePhotos from "./VehicleData/VehiclePhotos/VehiclePhoto.svelte";
	import EditMakeForm from "./VehicleData/VehicleMake/EditForm.svelte";
	import EditModelForm from "./VehicleData/VehicleModel/EditForm.svelte";
	import EditTypeForm from "./VehicleData/VehicleType/EditForm.svelte";
	import EditColorForm from "./VehicleData/VehicleColor/EditForm.svelte";
	import EditFuelForm from "./VehicleData/VehicleFuel/EditForm.svelte";
	import EditCarAssetOwnerForm from "./VehicleData/CarAssetOwner/EditForm.svelte";
	import EditCarParkOwner from "./VehicleData/CarParkOwner/EditCarParkForm.svelte";
	import EditFuelCompany from "./VehicleData/FuelCompany/EditFuelCompanyForm.svelte";
	import CreateTaskForm from "./PresetTask/CreateTaskForm.svelte";
	import CreateGroupForm from "./Group/CreateGroupForm.svelte";
	import CreateCarPhotos from "./VehicleData/VehiclePhotos/CreateCarPhotos.svelte";
	import EditCarPhotos from "./VehicleData/VehiclePhotos/EditCarPhotos.svelte";
	import VehicleEfficiency from "./VehicleData/VehicleEfficiency/VehicleEfficiency.svelte";
	import EditEfficiencyForm from "./VehicleData/VehicleEfficiency/EditEfficiencyForm.svelte";
	import CpoProvider from "./VehicleData/EVCPOProvider/CPOProvider.svelte";
	import EditEVForm from "./VehicleData/EVCPOProvider/EditForm.svelte";
	import EditTaskForm from "./PresetTask/EditTaskForm.svelte";
	import { brand } from "src/brand";
</script>

<Router url="/">
	<Route path="/group" component={Group} />
	<Route path="/vehicle-data" component={VehicleData} />
	<Route path="/vehicle-data/vehicle-make" component={VehicleMake} />
	<Route path="/vehicle-data/vehicle-model" component={VehicleModel} />
	<Route path="/vehicle-data/vehicle-type" component={VehicleType} />
	<Route path="/vehicle-data/vehicle-color" component={VehicleColor} />
	<Route path="/vehicle-data/vehicle-fuel" component={VehicleFuel} />
	<Route
		path="/vehicle-data/vehicle-asset-owner"
		component={VehicleAssetOwner}
	/>
	<Route path="/vehicle-data/carpark-owner" component={CarParkOwner} />
	<Route path="/vehicle-data/fuel-company" component={FuelCompany} />
	<Route path="/vehicle-data/vehicle-photos" component={VehiclePhotos} />
	<Route
		path="/vehicle-data/vehicle-efficiency"
		component={VehicleEfficiency}
	/>
	<Route path="/vehicle-data/vehicle-efficiency/edit/:id">
		<EditEfficiencyForm />
	</Route>
	{#if brand.isEVEnabled}
		<Route path="/vehicle-data/cpo-provider" component={CpoProvider} />
		<Route path="/vehicle-data/cpo-provider/edit/:id">
			<EditEVForm />
		</Route>
	{/if}
	<Route path="/vehicle-data/vehicle-make/edit/:id">
		<EditMakeForm />
	</Route>
	<Route path="/vehicle-data/vehicle-model/edit/:id">
		<EditModelForm />
	</Route>
	<Route path="/vehicle-data/vehicle-type/edit/:id">
		<EditTypeForm />
	</Route>
	<Route path="/vehicle-data/vehicle-color/edit/:id">
		<EditColorForm />
	</Route>
	<Route path="/vehicle-data/vehicle-fuel/edit/:id">
		<EditFuelForm />
	</Route>
	<Route path="/vehicle-data/vehicle-asset-owner/edit/:id">
		<EditCarAssetOwnerForm />
	</Route>
	<Route path="/vehicle-data/carpark-owner/edit/:id" let:params>
		<EditCarParkOwner recordId={params.id} />
	</Route>
	<Route path="/vehicle-data/fuel-company/edit/:id" let:params>
		<EditFuelCompany recordId={params.id} />
	</Route>
	<Route path="/vehicle-data/vehicle-photos/edit/:id">
		<EditCarPhotos />
	</Route>
	<Route path="/group/details/:id" component={GroupDetails} />
	<Route path="/group/create-group" component={CreateGroupForm} />
	<Route
		path="/vehicle-data/vehicle-photos/create"
		component={CreateCarPhotos}
	/>
	<Route path="/preset-task" component={PresetTask} />
	<Route path="/preset-task/:id" let:params>
		<EditTaskForm recordId={params.id} />
	</Route>
	<Route path="/preset-task/create" component={CreateTaskForm} />
</Router>
